import { IDataSet } from '../Track';

export class EntryPointDataSet implements IDataSet {
    public epContext: string = undefined;
    public epCustomEntryPoint: string= undefined;
    public entryPoint: string = undefined;
    public epSenderId: string = '';
    // public epSenderLevel: number = undefined;
    // public epSenderDaysInGame: number = undefined;
    // public epSenderCoins: number = undefined;
    // public epSenderIsPayer: number = undefined;
    // public epTimestamp: number = undefined;

    public epPromoSource: string = undefined;

    public epBotMsgCategory: string = undefined;
    public epBotMsgId: string = undefined;
    // public epBotGiftId: string = undefined;

    public epChanger: number = 0;
    public epRemoveOne: number = 0;
    public epMassRemove: number = 0;
    public epJoker: number = 0;
    public epCoins: number = 0;
    public epLives: number = 0;

    // public campaignID: string = undefined;
}
